import { memo, useEffect } from "react";
import useFontLoader from "../utils/usefontloader";
import usePropFormatter from "../utils/usepropformatter";
function Text(props) {
  const { _props } = usePropFormatter(props.block);
  useFontLoader(props.block.props);

  if (!_props) {
    return null;
  }

  return (
    <div
      ref={props.editorRef}
      style={{
        position: "relative",
        whiteSpace: "pre-wrap",
        visibility: props.block.hidden ? "hidden" : "unset",
        textOverflow: "ellipsis",
        overflow: "hidden",
        flexGrow: props.block.props.flexGrow,
        backgroundColor: props.block.props.backgroundColor,
        boxShadow: props.block.props.boxShadow,
        boxSizing: "border-box",
        ...props.block.props.textstyle,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
      }}
      //dangerouslySetInnerHTML={{ __html: _props.value }}
    >
      {_props.value}
    </div>
  );
}

export default memo(Text);
